// extracted by mini-css-extract-plugin
export default {"main":"SecondSection_main__zVfgv","topContainer":"SecondSection_topContainer__b42N8","title":"SecondSection_title__5zSZc","imgContainer":"SecondSection_imgContainer__MI6P5"};